import { render, staticRenderFns } from "./advantage.vue?vue&type=template&id=21b510de&scoped=true"
import script from "./advantage.vue?vue&type=script&lang=js"
export * from "./advantage.vue?vue&type=script&lang=js"
import style0 from "./advantage.vue?vue&type=style&index=0&id=21b510de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b510de",
  null
  
)

export default component.exports